/* tslint:disable:max-line-length */
import {FuseNavigationItem} from "fuseui";

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },
    {
        id: 'app-group',
        title: 'Kalkulace',
        subtitle: 'Kalkulace zákazníků',
        type: 'group',
        children: [
                {
                    id: 'calculation',
                    title: 'Realizované kalkulace',
                    type: 'basic',
                    icon: 'heroicons_outline:calculator',
                    link: '/calculation'
                },
                {
                    id: 'customer',
                    title: 'Zákazníci',
                    type: 'basic',
                    icon: 'feather:users',
                    link: '/customer'
                },
            ]
        },
    {
        id: 'app-group',
        title: 'Cenotvorba',
        subtitle: 'Nastavení kalkulací',
        type: 'group',
        children: [

                {
                    id: 'area-price',
                    title: 'Cenové hladiny',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-bar',
                    link: '/area-price'
                },
                {
                    id: 'area-price',
                    title: 'Koeficienty počtu',
                    type: 'basic',
                    icon: 'heroicons_outline:chart-bar',
                    link: '/count-price'
                },
                {
                    id: 'service',
                    title: 'Služby',
                    type: 'basic',
                    icon: 'heroicons_outline:plus-circle',
                    link: '/service'
                }
            ]
        },
    {
        id: 'app-group',
        title: 'Aplikace',
        subtitle: 'Vše co potřebujete vědět',
        type: 'group',
        children: [
            {
                id: 'users',
                title: 'Uživatelé',
                type: 'basic',
                icon: 'feather:user-check',
                link: '/users',
                role: 'other',
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog'
            }
        ]
    },
];

export const defaultNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },

    {
        id: 'app-group',
        title: 'Číselníky',
        subtitle: 'Číselníky pro správu',
        type: 'group',
        children: [
            {
                id: 'area-price',
                title: 'Cenové hladiny',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/area-price'
            },
        ]
    },
    {
        id: 'app-group',
        title: 'Aplikace VIP BenefitClub',
        subtitle: 'Vše co potřebujete vědět',
        type: 'group',
        children: [
            {
                id: 'support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support'
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog'
            }
        ]
    },
];

export const compactNavigation: FuseNavigationItem[] = [];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [];
